import ErrorFeedback from 'Components/ErrorFeedback'
import useModalEmailMessages from 'Hooks/useModalEmailMessages/useModalEmailMessages'
import {
  Flex,
  MODAL_SIZE_LG,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import HeaderMessageBox from './components/HeaderMessageBox'
import Search from './components/Search'
import TableMessages from './components/TableMessages'

const ModalEmailMessages = ({ handleCancel, handleConfirm, mode }) => {
  const intl = useIntl()
  const { show, loaded, error, errMessage, severity } =
    useModalEmailMessages(mode)

  return (
    <>
      <Modal
        data-mu-test='modal-email-messages'
        show={show}
        showClose
        onClose={handleCancel}
        closeOnOverlayClick
        size={MODAL_SIZE_LG}
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.SelectEmailMessage.Title'
          })}
        />
        <ModalBody scrollable>
          <Flex height='450px' flexDirection='column' rowGap='24px'>
            <ErrorFeedback error={errMessage} severity={severity} />
            {!error && loaded && (
              <>
                <HeaderMessageBox />
                <Search />
                <TableMessages handleConfirm={handleConfirm} />
              </>
            )}
          </Flex>
        </ModalBody>
        <ModalFoot />
      </Modal>
    </>
  )
}

ModalEmailMessages.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  mode: PropTypes.oneOf([undefined, 'Confirmation'])
}

export default ModalEmailMessages
